import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

/**
 * Retorna os dados formatados da equipe vinculada.
 *
 * @param {Object} item Cadastro
 * @return {String}
 */
function equipeVinculada(item) {
  if (!item.equipe_vinculada) {
    return ''
  }

  const ine = item.equipe_vinculada.nu_ine ?? ''
  const equipe = item.equipe_vinculada.no_equipe ?? ''

  if (!ine && !equipe) {
    return ''
  }

  if (!ine) {
    return equipe
  }

  if (!equipe) {
    return ine
  }

  return `${ine} - ${equipe}`
}

/**
 * Gera o PDF com os estabelecimentos e equipes.
 *
 * @param {Array} cadastros Cadastros exibidos na tabela
 * @param {String|null} tipoEquipe Tipo de equipe selecionado
 * @return {void}
 */
export function generatePdf(cadastros, tipoEquipe) {
  const titlePdf = 'Estabelecimentos, Equipes e Serviços'
  const titlePdfSave = utils.methods.titlePdf(titlePdf)
  const descriptionPdf =
    'Visualização de estabelecimentos e equipes e edição de serviços'

  const headersPdf = [
    'CNES',
    'UNIDADE DE SAÚDE',
    'INE',
    'EQUIPE',
    'TIPO EQUIPE',
    'EQUIPE VINCULADA',
  ]

  const dataPdf = cadastros.map((item) => {
    return {
      nu_cnes: item.nu_cnes ?? '',
      no_unidade_saude: item.no_unidade_saude ?? '',
      nu_ine: item.nu_ine ?? '',
      no_equipe: item.no_equipe ?? '',
      sg_tipo_equipe: item.sg_tipo_equipe ?? '',
      equipe_vinculada: equipeVinculada(item),
      rowColor: item.rowColor,
    }
  })

  const doc = new jsPDF({
    orientation: 'l',
    unit: 'pt',
    format: 'a4',
    ...utils.methods.encryptionPdf(),
  })

  const table = utils.methods.createTablePdf(dataPdf)

  const brasao = store.state.infoMunicipio.brasao

  utils.methods
    .fileToBase64(brasao)
    .then((base64data) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        titlePdf,
        descriptionPdf,
        200,
        'l'
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Serviços',
            value: tipoEquipe ?? '',
          },
        ],
        verticalPosition,
        'l'
      )

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 10,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 9,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let color = data.row.raw[6]

          // Header sempre preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
            return
          }

          if (color == 'green') {
            doc.setTextColor(2, 99, 57)
            return
          }

          if (color == 'red') {
            doc.setTextColor(194, 10, 16)
            return
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY, 250, 600, 'l')

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)

      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
